import type { Unsubscribe } from "../types";

/**
 * Returns an `onXxx(cb)` function backed by the given subscriber set.
 * Calling the returned unsubscribe removes the callback from the set.
 */
export const makeSubscriber =
  <T>(set: Set<(value: T) => void>) =>
  (cb: (value: T) => void): Unsubscribe => {
    set.add(cb);
    return () => {
      set.delete(cb);
    };
  };
